module.exports = __webpack_public_path__ + "static/img/bg_notlogin.c41266b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/card/header/bg_notlogin.png
// module id = hleJ
// module chunks = 6